export default "__VITE_ASSET__4_lFVU6G__"